import { Box, Image } from "@reverb-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ContentNotFound } from "../components/content-not-found";
import { FeaturedBannerBox } from "../components/featured-banner-box";
import GalleryImage from "@/assets/images/customer-gallery.svg";
import RockUImage from "@/assets/images/rock-university.svg";
import { sizes } from "@reverb-ui/tokens";
export var OutdoorContainer = function (_a) {
    var isRocker = _a.isRocker, isTalent = _a.isTalent, isClientEmployee = _a.isClientEmployee;
    var t = useTranslation("home").t;
    var banners = [];
    if (isTalent) {
        banners.push({
            callToActionButton: {
                link: "https://university.rockcontent.com",
                label: t("rock-university.call-to-action"),
            },
            description: (React.createElement(React.Fragment, null,
                React.createElement("b", null,
                    t("rock-university.highlighted-desc"),
                    " "),
                React.createElement("br", null),
                t("rock-university.desc"))),
            title: (React.createElement(Image, { h: sizes[14], src: "../../../assets/icons/products/rock-university.svg", alt: "Rock University Icon" })),
            image: React.createElement(RockUImage, null),
        });
    }
    if (isClientEmployee || isRocker) {
        banners.push({
            callToActionButton: {
                link: "https://rockcontent.com/gallery/",
                label: t("get-inspired"),
            },
            description: (React.createElement(React.Fragment, null,
                React.createElement("b", null,
                    t("need-inspiration"),
                    " "),
                " ",
                t("get-inspired-desc"))),
            title: t("customer-gallery"),
            image: React.createElement(GalleryImage, null),
        });
    }
    return (React.createElement(Box, { alignItems: "center", justifyContent: "space-between", mt: "12", w: "1180px", p: "8", bg: "white", boxShadow: "md", borderRadius: "12" }, banners.length === 0 ? (React.createElement(ContentNotFound, null)) : (React.createElement(FeaturedBannerBox, { banners: banners }))));
};
